import { render, staticRenderFns } from "./DemonstracaoTipoAnestesia.vue?vue&type=template&id=990179e0&scoped=true"
import script from "./DemonstracaoTipoAnestesia.vue?vue&type=script&lang=ts"
export * from "./DemonstracaoTipoAnestesia.vue?vue&type=script&lang=ts"
import style0 from "./DemonstracaoTipoAnestesia.vue?vue&type=style&index=0&id=990179e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990179e0",
  null
  
)

export default component.exports